import { BaseError } from '@kiplin/web-common/error';

export class CurrentClientUserLoadError extends BaseError {
  constructor(sourceError: unknown) {
    const message = sourceError instanceof Error ? sourceError.message : 'Unknown error';
    super('d1acbc3d-3c17-46d8-b0c0-94a7398822d1', `Unable to load current user information: ${message}`);
  }
}
